(() => {
	function init() {
		const els = document.querySelectorAll('[data-fit-text]');

		els.forEach((el) => {
			const minSize = parseInt(el.dataset.minSize) || 12;
			const maxSize = parseInt(el.dataset.maxSize) || 24;
			const multiLine = el.dataset.multiLine || true;

			textFit(el, {
				minFontSize: minSize,
				maxFontSize: maxSize,
				multiLine: multiLine
			});
		});
	}

	// Events
	// ----------------------------------------

	$DOC.ready(() => {
		init();
	});

	$WINDOW.on('page:content-updated', (e) => {
		init();
	});

	$WINDOW.on('resize:end', (e) => {
		init();
	});
})();
